import EventActionProto from 'core/gd-session/event-action-proto';

module.exports = class SessionMeetingNoteUpdate extends EventActionProto {

    constructor(uid, data, sid, companyId) {
        super(uid, data, companyId);
        this.fromSID = sid;
    }

    process() {
        // do not process event for user who initialed update
        if (this.fromSID === gd.sessionId) {
            // console.log("same user -> ignore");
            return false;
        }

        const noteId = this.data.id;

        gd.bus.triggerEvent('meeting-note.{0}:update'.f(noteId), this.data);

        super.process();
    }
};